var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C5C6B988-60AC-4F4A-BBCC-2C0A07282FC7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-1366",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reg_2_2_16-10-2019",
    transform: "translate(-483.000000, -441.000000)",
    fill: "#F92828",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal-Copy",
    transform: "translate(429.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0422\\u0440\\u0435\\u0431\\u043E\\u0432\\u0430\\u043D\\u0438\\u044F",
    transform: "translate(54.000000, 350.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,26 C12.4179677,26 16,29.5833226 16,34 C16,38.4192581 12.4179677,42 8,42 C3.58203226,42 0,38.4192581 0,34 C0,29.5833226 3.58203226,26 8,26 Z M8,27 C4.13062037,27 1,30.1369398 1,34 C1,37.8706759 4.13561111,41 8,41 C11.8691204,41 15,37.865912 15,34 C15,30.1135417 11.8441991,27 8,27 Z M8,37 C8.55228125,37 9,37.4477187 9,38 C9,38.5522813 8.55228125,39 8,39 C7.44771875,39 7,38.5522813 7,38 C7,37.4477187 7.44771875,37 8,37 Z M8.5,29 C8.77614237,29 9,29.2238576 9,29.5 L9,35.5 C9,35.7761424 8.77614237,36 8.5,36 L7.5,36 C7.22385763,36 7,35.7761424 7,35.5 L7,29.5 C7,29.2238576 7.22385763,29 7.5,29 L8.5,29 Z",
    id: "Combined-Shape-2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f29a0385.svg";
export { ForwardRef as ReactComponent };